import * as React from 'react';
import { useLazyQuery } from '@grandvisionhq/graphql';
import '../../operations/queries/get-accessories-by-slug.js';
import '../../operations/queries/get-contact-lens-by-slug.js';
import '../../operations/queries/get-frames-by-slug.js';
import '../../operations/queries/get-solutions-by-slug.js';
import '../../operations/queries/get-sunglasses-by-slug.js';
import '../../operations/queries/get-ready-reader-by-slug.js';
import { GET_CART_DISCOUNTS_BY_PROMOTION_IDENTIFIER } from '../../operations/queries/get-cart-discounts-by-promotion-identifier.js';
import { mapGraphCartDiscountToClientCartDiscount } from './map-to-client-cart-discount.js';
import { createCartDiscountError } from './types.js';

/*
 * Query the cart discounts by promotion identifier
 */ const useCartDiscounts = (promotionIdentifier, enabled = false)=>{
    const [discountError, setDiscountError] = React.useState(null);
    const [getCartDiscounts, { data , loading , error  }] = useLazyQuery(GET_CART_DISCOUNTS_BY_PROMOTION_IDENTIFIER);
    const mappedCartDiscounts = React.useMemo(()=>{
        if (!(data === null || data === void 0 ? void 0 : data.getCartDiscountsByPromotionIdentifier)) {
            return [];
        }
        return mapGraphCartDiscountToClientCartDiscount(data.getCartDiscountsByPromotionIdentifier);
    }, [
        data === null || data === void 0 ? void 0 : data.getCartDiscountsByPromotionIdentifier
    ]);
    React.useEffect(()=>{
        if (enabled && promotionIdentifier) {
            getCartDiscounts({
                variables: {
                    promotionIdentifier
                }
            });
        }
    }, [
        promotionIdentifier,
        enabled
    ]);
    React.useEffect(()=>{
        if (error) {
            setDiscountError(createCartDiscountError('CART_DISCOUNT_ERROR', error));
        }
    }, [
        error
    ]);
    return React.useMemo(()=>{
        return {
            loading,
            cartDiscounts: mappedCartDiscounts,
            error: discountError
        };
    }, [
        loading,
        mappedCartDiscounts,
        discountError
    ]);
};

export { useCartDiscounts };
//# sourceMappingURL=use-cart-discounts.js.map
